import { gradeTypes } from '$variables/constants';

// legacy assignment (without gradeType) doesn't have selectedGradeType
// we consider legacy assignment as freeform
const adaptLegacyGradeType = (gradeType) => {
  if (!gradeType) {
    return gradeTypes.freeform;
  }

  return gradeType;
};

export default adaptLegacyGradeType;
